import React, { memo } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Icon } from '../../../../globalUtils/globalIcons';
import './remoteCommandExecutionLogs.css';

interface ExecutionStatusChipProps {
  label: string;
  variant: string;        // ChipVariant, or 'source rms' / 'source cms' / 'source local'
  showDot?: boolean;      // dot in place of the status icon
}

function ExecutionStatusChip({ label, variant, showDot }: ExecutionStatusChipProps) {
  return (
    <span className={'remote__command__logs-chip ' + variant}>
      {showDot && <span className='remote__command__logs-chip-dot'></span>}
      {!showDot && variant === 'in-progress' && <span className='remote__command__logs-chip-progress-icon'></span>}
      {!showDot && variant === 'pending' && <AccessTimeIcon className='remote__command__logs-chip-icon' />}
      {!showDot && variant === 'success' && <Icon iconClassName='status__device_parameter__success__icon' />}
      {!showDot && variant === 'failed' && <Icon iconClassName='status__device_parameter_failed__icon' />}
      {label}
    </span>
  );
}

export default memo(ExecutionStatusChip);
